<template>
  <v-row
    dense
    justify="center"
    class="elevation-1 px-4 mx-2 py-4 my-5 grey lighten-2"
  >
    <v-col cols="12">
      <h3 class="pa-3">{{ $t('conflict.isThereAFavoriteOption') }} ?</h3>
    </v-col>

    <v-hover
      v-slot:default="{ hover }"
    >
      <v-card
        @click="selectMode(1)"
        :elevation="hover ? 12 : 2"
        :class="`rai-select-option-card ma-2 pa-3 ${selectedOptionMode === 1 ? 'primary' : ''}`"
        outlined
        min-width="220px"
        max-width="22%"
        width="22%"
      >
        <h4 :class="`text-capitalize text-center ${selectedOptionMode === 1 ? 'white' : 'primary'}--text`">{{$t('global.yes') }}</h4>
        <br />
        <p :class="`text-center ${selectedOptionMode === 1 ? 'white' : 'black'}--text`">{{ $t('conflict.exclusiveAndUnique') }}</p>
      </v-card>
    </v-hover>

    <v-hover
      v-slot:default="{ hover }"
    >
      <v-card
        @click="selectMode(2)"
        :elevation="hover ? 12 : 2"
        :class="`rai-select-option-card ma-2 pa-3 ${selectedOptionMode === 2 ? 'primary' : ''}`"
        outlined
        min-width="220px"
        max-width="22%"
        width="22%"
      >
        <h4 :class="`text-capitalize text-center ${selectedOptionMode === 2 ? 'white' : 'primary'}--text`">{{$t('global.no') }}</h4>
        <br />
        <p :class="`text-center ${selectedOptionMode === 2 ? 'white' : 'black'}--text`">{{ $t('conflict.butAddingInfoItCould') }}</p>
      </v-card>
    </v-hover>

    <v-hover
      v-slot:default="{ hover }"
    >
      <v-card
        @click="selectMode(3)"
        :elevation="hover ? 12 : 2"
        :class="`rai-select-option-card ma-2 pa-3 ${selectedOptionMode === 3 ? 'primary' : ''}`"
        outlined
        min-width="220px"
        max-width="22%"
        width="22%"
        v-show="!hideNoIPreferMakingGroups"
      >
        <h4 :class="`text-capitalize text-center ${selectedOptionMode === 3 ? 'white' : 'primary'}--text`">{{$t('global.no') }}</h4>
        <br />
        <p :class="`text-center ${selectedOptionMode === 3 ? 'white' : 'black'}--text`">{{ $t('conflict.iPreferMakingGroups') }}</p>
      </v-card>
    </v-hover>

    <v-hover
      v-slot:default="{ hover }"
    >
      <v-card
        @click="selectMode(6)"
        :elevation="hover ? 12 : 2"
        :class="`rai-select-option-card ma-2 pa-3 ${selectedOptionMode === 6 ? 'primary' : ''}`"
        outlined
        min-width="220px"
        max-width="22%"
        width="22%"
        v-show="!hideNoICanNotDecide"
      >
        <h4 :class="`text-capitalize text-center ${selectedOptionMode === 6 ? 'white' : 'primary'}--text`">{{$t('global.no') }}</h4>
        <br />
        <p :class="`text-center ${selectedOptionMode === 6 ? 'white' : 'black'}--text`">{{ $t('conflict.iCantChooseAllThoseOptionsAreEqual') }}</p>
      </v-card>
    </v-hover>
  </v-row>
</template>

<script>
export default {
  name: 'FavoriteOption',

  props: {
    selectedOptionMode: {
      type: Number,
      required: false,
      default: 0,
    },
    hideNoIPreferMakingGroups: {
      type: Boolean,
      required: true,
    },
    hideNoICanNotDecide: {
      type: Boolean,
      required: true,
    }
  },

  methods: {
    selectMode (mode) {
      this.$emit('selectOptionMode', mode);
    },
  },
};
</script>

<style>
.rai-select-option-card {
  cursor: pointer;
}
</style>
